"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight, Building2, Cog, HardHat } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const disciplines = [{
  id: "CAD-01",
  title: "Jewelry CAD Design",
  description: "High-precision 3D modeling for bespoke jewelry. Deliverables include production-ready .3dm, .stl files, and photorealistic .jpg renderings.",
  icon: Building2,
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_cad_wireframe.png)]",
  link: "/InvestmentPage"
}, {
  id: "PRN-02",
  title: "3D Wax Printing",
  description: "Professional high-resolution wax printing for casting. Precision levels optimized for fine detail. Minimum order of 7 pieces required.",
  icon: Cog,
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_wax_samples.png)]",
  link: "/InvestmentPage"
}, {
  id: "EST-03",
  title: "Custom Quotations",
  description: "Submit your job for a personalized quote. Pricing ranges from $50 to $200+ for CAD and $15 to $150 for 3D printing services.",
  icon: HardHat,
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_render_preview.png)]",
  link: "/StartYourProjectPage"
}];
export default function OurCoreTechnicalDisciplines() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224944" id="our-core-expertise" className="relative bg-background text-foreground py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:32px_32px] opacity-10 pointer-events-none" />
      
      <div className="container mx-auto px-4 max-w-7xl relative z-10">
        <div ref={headerRef} className={`mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex items-center gap-4 mb-4">
            <div className="h-px w-12 bg-secondary" />
            <span className="font-mono text-sm text-secondary uppercase tracking-widest">
              Digital Craftsmanship
            </span>
          </div>
          <h2 className="font-default text-4xl md:text-5xl font-bold text-primary">
            Our Core Expertise
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
          {disciplines.map((item, i) => <div data-index={i} key={item.id} className="h-full">
              <Card className="group relative h-full rounded-md border border-border bg-card/40 backdrop-blur-md overflow-hidden transition-all duration-500 hover:border-secondary/50 hover:shadow-3xl hover:-translate-y-1">
                {}
                <div className={`absolute inset-0 bg-cover bg-center opacity-10 mix-blend-luminosity transition-all duration-700 group-hover:opacity-30 group-hover:scale-105 ${item.bgClass}`} />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-b from-transparent to-background/90 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                <CardContent className="relative z-10 p-8 flex flex-col h-full">
                  <div className="mb-auto">
                    <div className="flex justify-between items-start mb-8">
                      <item.icon className="size-10 text-muted-foreground group-hover:text-secondary transition-colors duration-300" strokeWidth={1} />
                      <span className="font-mono text-xs text-muted-foreground/50 group-hover:text-secondary/70 transition-colors duration-300">
                        {item.id}
                      </span>
                    </div>
                    
                    <h3 className="font-default text-2xl font-semibold text-foreground mb-4">
                      {item.title}
                    </h3>
                    <p className="font-default text-muted-foreground text-sm leading-relaxed">
                      {item.description}
                    </p>
                  </div>

                  {}
                  <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-all duration-500 ease-in-out">
                    <div className="overflow-hidden">
                      <div className="pt-8">
                        <Link to={item.link} className="inline-flex items-center gap-2 font-mono text-sm text-secondary uppercase tracking-wider hover:text-primary transition-colors after:absolute after:inset-0">
                          View Details
                          <ArrowRight className="size-4 transform group-hover:translate-x-1 transition-transform duration-300" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  
                  {}
                  <div className="absolute top-0 left-0 w-2 h-2 border-t border-l border-secondary/0 group-hover:border-secondary/50 transition-colors duration-300" />
                  <div className="absolute top-0 right-0 w-2 h-2 border-t border-r border-secondary/0 group-hover:border-secondary/50 transition-colors duration-300" />
                  <div className="absolute bottom-0 left-0 w-2 h-2 border-b border-l border-secondary/0 group-hover:border-secondary/50 transition-colors duration-300" />
                  <div className="absolute bottom-0 right-0 w-2 h-2 border-b border-r border-secondary/0 group-hover:border-secondary/50 transition-colors duration-300" />
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}